export const TEST_ID = 'desktopNavigationDropdownOnClick';
